/** Picks the home closing CTA variant from signals already on the client. Pure; tested. */
export type NextStepVariant = "situation" | "reader" | "brown" | "green" | "amber";

export const ROTATION_KEY = "home-next-step-visit";
const ROTATION: NextStepVariant[] = ["brown", "green", "amber"];

export function rotationVariant(counter: number, hasWhatsApp: boolean): NextStepVariant {
  const pool = hasWhatsApp ? ROTATION : ROTATION.filter((v) => v !== "amber");
  const n = Number.isFinite(counter) && counter >= 0 ? Math.floor(counter) : 0;
  return pool[n % pool.length];
}

export function pickNextStep(input: {
  situation: boolean;
  readerActive: boolean;
  counter: number;
  hasWhatsApp: boolean;
}): NextStepVariant {
  if (input.situation) return "situation";
  if (input.readerActive) return "reader";
  return rotationVariant(input.counter, input.hasWhatsApp);
}

/** Reads and bumps the per-session visit counter; any storage failure yields 0 (brown). */
export function nextVisitCounter(storage: Pick<Storage, "getItem" | "setItem"> | null | undefined): number {
  try {
    if (!storage) return 0;
    const cur = Number(storage.getItem(ROTATION_KEY) ?? "0");
    const n = Number.isFinite(cur) && cur >= 0 ? cur : 0;
    storage.setItem(ROTATION_KEY, String(n + 1));
    return n;
  } catch {
    return 0;
  }
}
